import { DashboardProvider } from "@app/components/Dashboard/DashboardProvider";
import { DetailListSection } from "@app/components/Dashboard/section/DetailListSection";
import { MainDescription } from "@app/components/MainContainer/MainDescription";
import { DashboardHeader } from "src/components/Dashboard/DashboardHeader";
import { MetricSection } from "@app/components/Dashboard/section/MetricSection";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { MainContentContainer } from "@app/components/MainContainer";
import { MainContent } from "@app/components/MainContainer/MainContent";
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { ReportTimeSchema } from "@app/pages/Dashboard/reportTimeSchema";
import { useModal } from "@shortsworks/ui";
import { useGetListStatisticsReportMetricsGet } from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import { Fragment, Children, useState } from "react";

export type ReportTimeWindow =
  | "7d"
  | "14d"
  | "30d"
  | "yesterday"
  | "today"
  | "this_month"
  | "last_month"
  | "custom";

export const Dashboard = () => {
  const { showModal } = useModal();
  const { data, isSuccess } = useGetListStatisticsReportMetricsGet();

  const [timeWindow, setTimeWindow] = useState<ReportTimeWindow>("7d");
  const [customDateRange, setCustomDateRange] = useState<
    { startDate: Date; endDate: Date } | undefined
  >(undefined);
  const [isDataEmpty, setIsDataEmpty] = useState<boolean>(false);

  const { form, schemas } = useFormWithSchema({
    formSchemas: ReportTimeSchema,
  });

  const handleChangeTimeWindow = (
    value: ReportTimeWindow,
    customRange?: { startDate: Date; endDate: Date },
  ) => {
    setTimeWindow(value);
    setCustomDateRange(customRange);
  };

  const handleDataState = (empty: boolean) => {
    setIsDataEmpty(empty);
  };

  if (!isSuccess) {
    return (
      <div className="flex w-full h-full items-center justify-center">
        <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
      </div>
    );
  }

  return (
    <MainContentContainer>
      <MainHeader>
        <MainTitle>통계</MainTitle>
        <MainDescription>조회수와 시청 완료율 등의 통계 정보를 볼 수 있습니다.</MainDescription>
      </MainHeader>
      <MainContent>
        <DashboardProvider
          initialTimeWindow="7d"
          initialCustomDateRange={undefined}
          initialDataIsEmpty={false}
        >
          <div
            className="h-full pr-1 max-w-full"
            // paddingInline={{mobileOnly: "16px"}} width="100%" maxWidth={{mobile: "100%", tablet: 900}}
          >
            <DashboardHeader />
            <MetricSection />
            <DetailListSection />
          </div>
        </DashboardProvider>
      </MainContent>
    </MainContentContainer>
  );
};
